import React from "react";

import { Typography } from "@material-ui/core";

import { useAppSelector } from "store";
import { selectStore } from "modules/customer/insights/portfolioNew/portfolioSlice";

const RetailComplexionTitle: React.FC = () => {
    const selectedStore = useAppSelector(selectStore);

    return (
        <Typography variant="h6" component="div" gutterBottom>
            Retail mix within your {selectedStore?.name} store's retail zone
        </Typography>
    );
};

export default RetailComplexionTitle;
